import { render, staticRenderFns } from "./ListItems.vue?vue&type=template&id=c3ec6922&"
import script from "./ListItems.vue?vue&type=script&lang=ts&"
export * from "./ListItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports